import * as React from 'react';
import { TZUtils } from 'lib/TZUtils';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';

import { DateRange } from 'portcall/daterangeselector/model';
import { parseDateRange, outboundDateRangeParams } from 'portcall/daterangeselector/routeParams';
import { parseDate, serializeDate } from 'common/services/routeParams';
import { RowExpansionMode } from 'portcall/gridcomponents/model';

import { PastExports, PastExportsParams } from './pastexports';
import { PastExportsView } from './pastexportsview';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function PastExportsRoute(
    model : (params : PastExportsParams) => PastExports,
    appWrapper : AppWrapper,
    tzutils : TZUtils,
    request : Location
) : IRoute {
    const m = model(inboundParams(request, tzutils));

    return {
        view:
            <AppWrapperView model={appWrapper}>
                <PastExportsView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location, tzutils : TZUtils) : PastExportsParams {
    const id = +(request.params['id'] || 0),
        range = request.params['range'],
        from = request.params['from'],
        to = request.params['to'],
        expansionMode = request.params['expansion'],
        filter = request.params['filter'];

    return {
        id,
        range: range !== undefined ? parseDateRange(range) : DateRange.ThisMonth,
        from: from !== undefined ? parseDate(from, tzutils) : undefined,
        to: to !== undefined ? parseDate(to, tzutils) : undefined,
        expansionMode: expansionMode !== undefined ? +expansionMode : RowExpansionMode.AutoCollapse,
        filter
    };
}

function outboundParams(request : Location, m : PastExports) {
    const params = {} as LocationParams;
    params['id'] = m.Model().Id() + '';
    outboundDateRangeParams(m.DateRangeSelector, params, DateRange.ThisMonth, { range: 'range', from: 'from', to: 'to' });
    if (m.RowExpander.ExpansionMode() !== RowExpansionMode.AutoCollapse)
        params['expansion'] = m.RowExpander.ExpansionMode() + '';
    if (m.Filter()) params['filter'] = m.Filter();
    return new Location(request.name, params);
}



// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/pastexportsroute.tsx